/*
  Rellena las rejillas de relacionados con la Product Recommendations API.

  Shopify devuelve la seccion ya renderizada, asi que aqui solo se pide y se
  sustituye. Se hace en cuanto la seccion se acerca al viewport para no competir
  con la carga de la foto principal, que es lo que el comprador mira primero.
*/

(function () {
  'use strict';

  function load(container) {
    var url = container.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('recommendations ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-costa-related] .page-width');
        // Sin recomendaciones no se deja un titulo huerfano: la seccion entera
        // se queda vacia y no ocupa espacio.
        if (fresh) container.innerHTML = fresh.outerHTML;
      })
      .catch(function () {
        /* Si falla, la seccion simplemente no aparece. */
      });
  }

  function init() {
    document.querySelectorAll('[data-costa-related]').forEach(function (container) {
      if (container.dataset.costaLoaded) return;
      container.dataset.costaLoaded = '1';

      if (!('IntersectionObserver' in window)) {
        load(container);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            load(container);
          });
        },
        { rootMargin: '400px' }
      );

      observer.observe(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
